import { cn } from '@/lib/utils'

export type CardOpenControlProps = {
  /** Announced control name, e.g. "Open job Senior engineer". */
  ariaLabel: string
  onOpen: () => void
  /** Match the host surface's radius so the focus ring hugs the card. */
  rounded?: 'md' | 'xl'
  className?: string
}

/**
 * Stretched, pointer-transparent open control for interactive cards.
 * Keyboard and assistive tech get a real `<button>` (Enter/Space, focus ring)
 * while mouse clicks pass through to the host container's `onClick` — so inner
 * actions are never nested inside a button role. Host must be `position: relative`.
 */
export function CardOpenControl({
  ariaLabel,
  onOpen,
  rounded = 'xl',
  className,
}: CardOpenControlProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      className={cn(
        'pointer-events-none absolute inset-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        rounded === 'md' ? 'rounded-md' : 'rounded-xl',
        className,
      )}
      onClick={(event) => {
        event.stopPropagation()
        onOpen()
      }}
    />
  )
}
